var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1606_5064)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8637 18.616L11.9318 19.5478C11.0856 20.3804 9.94467 20.8448 8.75756 20.84C7.57044 20.8352 6.43332 20.3614 5.5939 19.522C4.75447 18.6826 4.28075 17.5455 4.27592 16.3584C4.27108 15.1713 4.73553 14.0303 5.56809 13.1841L7.8284 10.9285C8.63917 10.116 9.72972 9.64414 10.877 9.60929C12.0242 9.57443 13.1414 9.97926 14 10.741",
    stroke: "#383735",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1363 6.61596L13.0681 5.68409C13.9144 4.85153 15.0553 4.38708 16.2424 4.39191C17.4295 4.39675 18.5666 4.87047 19.4061 5.7099C20.2455 6.54932 20.7192 7.68644 20.724 8.87355C20.7289 10.0607 20.2644 11.2016 19.4319 12.0478L17.1716 14.3082C16.3602 15.1199 15.2693 15.591 14.1221 15.6249C12.9749 15.6589 11.858 15.2533 11 14.491",
    stroke: "#383735",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1606_5064"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5 0.615967)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon);
export default __webpack_public_path__ + "static/media/linkIcon.29983c44.svg";
export { ForwardRef as ReactComponent };